import { useAccordion } from "@material-tailwind/react";
import React, { useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import arrow from "../../assets/images/icon_tab/arrow.svg";

const ComponentAttendance = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);
  const env = Config.BaseUrlDev;

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_base/image/get/" + photo + "/pas";
  };

  const goToDetail = async (data: string) => {
    navigate(`/attendance-detail`, {
      state: {
        data: JSON.stringify(data),
        date: moment().format("yyyy-MM-DD"),
      },
    });
  };

  useEffect(() => {}, []);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 ${funBg}`}>
        <TabsMobile
          name={`${t("ATTENDANCE.title")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div>
      <section className="px-4 py-4 flex flex-col gap-3 top-to-bottom">
        {user.accounts[0].callerIdentities.map((res: any) => (
          <div
            onClick={() => goToDetail(res)}
            className="bg-white p-3 rounded-xl flex-row flex gap-3 items-center flex-0"
          >
            <div className="flex-0 w-14 h-14">
              <img
                src={getProfileImage(res.photoUrl)}
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <div className="flex flex-col grow">
              <h1 className="font-montserrat text-xs  font-medium text-psp-nav">
                {res.name}
              </h1>
              <span className="font-montserrat  font-medium text-psp-gray text-xs">
                NIS: {res.callerId}
              </span>
            </div>
            <img
              src={arrow}
              style={{ width: 6, height: 12 }}
              className="m-auto rotate-180 flex-0"
            />
          </div>
        ))}
      </section>
    </div>
  );
};

export default ComponentAttendance;
